module.exports = __webpack_public_path__ + "img/bkg_reviews.d8f05468.png";